import { gql } from "graphql-request";

export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      id
      legalName
      tradingName
      industry
      companySizeBand
      websiteURL
      linkedInURL
      phone
      email
      status
      primaryContactID
      activeTenantID
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      id
      legalName
      tradingName
      industry
      companySizeBand
      websiteURL
      linkedInURL
      phone
      email
      status
      primaryContactID
      activeTenantID
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const ARCHIVE_COMPANY = gql`
  mutation ArchiveCompany($id: ID!) {
    archiveCompany(id: $id)
  }
`;